import ShopifyClient from "services/shopify-client";

export const getExistingCheckoutId = () => localStorage.getItem("checkoutId");

const UserCheckoutId = async () => {
  const checkoutId = getExistingCheckoutId();
  if (checkoutId) {
    const checkout = await ShopifyClient.checkout.fetch(checkoutId);

    if (checkout && checkout.completedAt === null) return checkoutId;
  }

  let newCheckout;
  if (window?.wgs?.customerReferenceId) {
    newCheckout = await ShopifyClient.checkout.create({
      customAttributes: [
        {
          key: "_customerReferenceId",
          value: window?.wgs?.customerReferenceId,
        },
      ],
    });
  } else {
    newCheckout = await ShopifyClient.checkout.create();
  }


  localStorage.setItem("checkoutId", newCheckout.id);
  return newCheckout.id;
};

export default UserCheckoutId;
